// extracted by mini-css-extract-plugin
export default {"services":"Services_services__O4Heq","serviceDescritpion":"Services_serviceDescritpion__pLVTp"};